import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import cx from 'classnames'
import log from 'loglevel'

import { THEMES } from './constants'

import './style.scss'

export default class ProgressBar extends Component {
    static propTypes = {
        hasLabel: PropTypes.bool,
        labelPostfix: PropTypes.string,
        message: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        sideOffset: PropTypes.number,
        theme: PropTypes.oneOf([THEMES.BASE, THEMES.BLUE]),
        threshold: PropTypes.number,
        total: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    }

    static defaultProps = {
        hasLabel: true,
        message: null,
        sideOffset: 2, // two percent (magic constant :) )
        threshold: 80, // null for disable threshold
        theme: THEMES.BASE,
    }

    renderLabel = () => {
        const { value, total, sideOffset, hasLabel, labelPostfix } = this.props

        if (!hasLabel) return null

        const leftOffset = _.clamp(value / (total / 100), 0, 100) // in percent
        const rightOffset = 100 - leftOffset

        return (
            <div className={'label-container'}>
                <div className={'label-wrap'}>
                    <div className={'spacer'} style={{ width: `${_.clamp(leftOffset - sideOffset, 0, 100)}%` }} />
                    <div className={cx('label')}>{labelPostfix ? `${value}${labelPostfix}` : value}</div>
                    <div className={'spacer'} style={{ width: `${_.clamp(rightOffset - sideOffset, 0, 100)}%` }} />
                </div>
                <div
                    className={cx('arrow')}
                    style={{ left: `${_.clamp(leftOffset, sideOffset, 100 - sideOffset)}%` }}
                />
            </div>
        )
    }

    render() {
        const { value, total, threshold, message, theme } = this.props

        if (total <= 0) {
            log.warn('Total in ProgressBar must be greater than 0')
            return null
        }

        const width = _.clamp(value / (total / 100), 0, 100) // in percent
        const isThreshold = !_.isNull(threshold) && threshold > 0 && width >= threshold

        return (
            <div className={cx('progress-bar', isThreshold && 'threshold', theme)}>
                {this.renderLabel()}
                <div className={cx('bar')}>
                    <div className={cx('loaded')} style={{ width: `${width}%` }} />
                </div>
                {message && <div className={'message'}>{message}</div>}
            </div>
        )
    }
}
